import { render, staticRenderFns } from "./RoleManager.vue?vue&type=template&id=0feee6fc&scoped=true&"
import script from "./RoleManager.vue?vue&type=script&lang=js&"
export * from "./RoleManager.vue?vue&type=script&lang=js&"
import style0 from "./RoleManager.vue?vue&type=style&index=0&id=0feee6fc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0feee6fc",
  null
  
)

export default component.exports